export default function returntypeof<RT>(expression: (...params: any[]) => RT): RT {
  return {} as RT;
}